var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-section"},[_c('div',{staticClass:"logo-img",on:{"click":function($event){return _vm.$router.push({
			name: 'Login'
		})}}},[_c('img',{attrs:{"src":"/img/Dimitra Deforestation Compliance Logo White.png"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }